/* eslint-disable import/prefer-default-export */

export enum Errors {
  SERVICE_NOT_AVAILABLE = 500,
}
